import { createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const DICTS = {
  es: {
    navHome: "Inicio",
    navCars: "Coches",
    navAbout: "Nosotros",
    navContact: "Contacto",
    topBarHours: "Lun - Sáb: 09:00 - 19:00",
    heroEyebrow: "COMPRA - VENTA DE VEHÍCULOS DE OCASIÓN",
    heroTitle: "Coches de ocasión\nen la Costa del Sol",
    heroSub:
      "Vehículos revisados a buen precio en Mijas, Málaga. Servimos también a clientes de Fuengirola, Marbella y toda la provincia.",
    heroCtaCars: "VER COCHES",
    heroCtaContact: "CONTACTAR",
    statCars: "coches en stock",
    statAreas: "zonas: Málaga, Fuengirola, Mijas, Marbella",
    statDirect: "trato directo, sin intermediarios",
    statWhatsapp: "respuesta rápida por WhatsApp",
    carsEyebrow: "NUESTRA FLOTA",
    carsTitle: "Coches disponibles",
    carsSub: "Haz clic en un coche para ver todos los detalles y fotos",
    loading: "Cargando...",
    filterAllBrands: "Todas las marcas",
    filterAllTypes: "Todos los tipos",
    filterAllFuels: "Todos los combustibles",
    filterAllTransmissions: "Todas las transmisiones",
    filterBrand: "Marca",
    filterBodyType: "Tipo",
    filterFuel: "Combustible",
    filterTransmission: "Transmisión",
    filterClear: "Limpiar filtros",
    filterResultsOne: "1 coche encontrado",
    filterResults: (n) => `${n} coches encontrados`,
    filterNoResults: "No hay coches que coincidan con estos filtros.",
    viewDetails: "VER DETALLES",
    consultPrice: "Consultar precio",
    aboutEyebrow: "SOBRE NOSOTROS",
    aboutTitle: "Tu concesionario de confianza en Mijas",
    aboutP1:
      "Cheap Cars in Spain es un concesionario de coches de ocasión ubicado en Mijas, Málaga. Ayudamos a particulares de toda la Costa del Sol a encontrar su próximo coche a buen precio, con trato cercano y sin complicaciones.",
    aboutP2:
      "Vendemos en Málaga, Fuengirola, Mijas y Marbella, y podemos coordinar la visita, la prueba y toda la documentación del vehículo.",
    aboutP3:
      "¿No encuentras el coche que buscas en nuestro stock? Podemos conseguirte el vehículo que necesitas. Basta con ponerte en contacto con nosotros y nos encargamos de buscarlo, sin ningún compromiso por tu parte.",
    aboutFeatures: [
      "Vehículos revisados antes de la venta",
      "Trato directo y sin presión",
      "Documentación y transferencia gestionadas",
      "Contacto rápido por WhatsApp o formulario",
    ],
    contactEyebrow: "HABLEMOS",
    contactTitle: "Contacta con nosotros",
    contactInfoTitle: "Ponte en contacto",
    contactInfoSub:
      "Escríbenos por WhatsApp o rellena el formulario y te responderemos lo antes posible.",
    labelAddress: "Dirección",
    labelPhone: "Teléfono / WhatsApp",
    labelHours: "Horario",
    formName: "Nombre y apellidos",
    formNamePh: "Tu nombre",
    formEmail: "Correo electrónico",
    formEmailPh: "tu@email.com",
    formPhone: "Teléfono",
    formPhonePh: "+34 600 000 000",
    formCar: "Coche que te interesa",
    formCarNotSure: "No estoy seguro/a",
    formMessage: "Mensaje",
    formMessagePh: "Cuéntanos qué buscas...",
    formSubmit: "ENVIAR MENSAJE",
    formSending: "ENVIANDO...",
    thankYouTitle: "Mensaje recibido",
    thankYouSub: "Gracias por contactar con nosotros. Te responderemos lo antes posible.",
    formError: "No se pudo enviar el mensaje. Prueba de nuevo o escríbenos por WhatsApp.",
    footerRights: "Todos los derechos reservados.",
    footerTagline: "Coches de ocasión · Costa del Sol",
    whatsappFloat: "Escríbenos por WhatsApp",
    whatsappDefaultMsg: "Hola, me gustaría más información sobre vuestros coches.",
    whatsappCarMsg: (title) => `Hola, me interesa el ${title}. ¿Me dais más información?`,
    backToCars: "← Volver a todos los coches",
    year: "Año",
    km: "Kilómetros",
    transmission: "Transmisión",
    fuel: "Combustible",
    power: "Potencia",
    color: "Color",
    bodyType: "Tipo",
    contactAboutThisCar: "CONTACTAR SOBRE ESTE COCHE",
    whatsappAboutThisCar: "PREGUNTAR POR WHATSAPP",
    notFoundTitle: "Coche no encontrado",
    notFoundSub: "Este vehículo ya no está disponible o el enlace no es correcto.",
    pageNotFoundTitle: "Página no encontrada",
    pageNotFoundSub: "La página que buscas no existe. Echa un vistazo a nuestros coches disponibles.",
    photoOf: (i, n) => `${i} / ${n}`,
    transmissionVals: { automatic: "Automático", manual: "Manual" },
    fuelVals: {
      diesel: "Diésel",
      diesel_hybrid: "Diésel híbrido",
      gasoline: "Gasolina",
      hybrid: "Híbrido",
      plugin_hybrid: "Híbrido enchufable",
    },
    colorVals: {
      blue: "Azul",
      dark_blue: "Azul oscuro",
      white: "Blanco",
      silver: "Plateado",
      black: "Negro",
      red: "Rojo",
      grey: "Gris",
    },
    bodyTypeVals: {
      sedan: "Berlina",
      suv: "SUV",
      coupe: "Coupé",
      van: "Furgoneta",
      estate: "Familiar",
      hatchback: "Compacto",
      convertible: "Descapotable",
      minivan: "Monovolumen",
    },
    descriptionTitle: "Descripción",
    highlightsTitle: "Equipamiento destacado",
  },
  en: {
    navHome: "Home",
    navCars: "Cars",
    navAbout: "About",
    navContact: "Contact",
    topBarHours: "Mon - Sat: 09:00 - 19:00",
    heroEyebrow: "USED CARS - BOUGHT & SOLD",
    heroTitle: "Second-hand cars\non the Costa del Sol",
    heroSub:
      "Inspected vehicles at honest prices in Mijas, Málaga. We also serve customers in Fuengirola, Marbella and across the province.",
    heroCtaCars: "VIEW CARS",
    heroCtaContact: "CONTACT US",
    statCars: "cars in stock",
    statAreas: "areas: Málaga, Fuengirola, Mijas, Marbella",
    statDirect: "direct deal, no middlemen",
    statWhatsapp: "fast reply on WhatsApp",
    carsEyebrow: "OUR FLEET",
    carsTitle: "Available cars",
    carsSub: "Click on a car to see full details and photos",
    loading: "Loading...",
    filterAllBrands: "All brands",
    filterAllTypes: "All types",
    filterAllFuels: "All fuel types",
    filterAllTransmissions: "All transmissions",
    filterBrand: "Brand",
    filterBodyType: "Type",
    filterFuel: "Fuel",
    filterTransmission: "Transmission",
    filterClear: "Clear filters",
    filterResultsOne: "1 car found",
    filterResults: (n) => `${n} cars found`,
    filterNoResults: "No cars match these filters.",
    viewDetails: "VIEW DETAILS",
    consultPrice: "Contact for price",
    aboutEyebrow: "ABOUT US",
    aboutTitle: "Your trusted dealership in Mijas",
    aboutP1:
      "Cheap Cars in Spain is a used car dealership based in Mijas, Málaga. We help people across the Costa del Sol find their next car at a fair price, with honest, no-pressure service.",
    aboutP2:
      "We sell to customers in Málaga, Fuengirola, Mijas and Marbella, and can arrange viewings, test drives and all vehicle paperwork.",
    aboutP3:
      "Can't find the car you're looking for in our current stock? We can source it for you. Just get in touch and we'll take care of finding it — no obligation on your part.",
    aboutFeatures: [
      "Vehicles inspected before sale",
      "Direct, no-pressure dealing",
      "Paperwork and transfer handled for you",
      "Fast contact by WhatsApp or form",
    ],
    contactEyebrow: "LET'S TALK",
    contactTitle: "Get in touch",
    contactInfoTitle: "Contact us",
    contactInfoSub:
      "Message us on WhatsApp or fill in the form and we'll reply as soon as possible.",
    labelAddress: "Address",
    labelPhone: "Phone / WhatsApp",
    labelHours: "Opening hours",
    formName: "Full name",
    formNamePh: "Your name",
    formEmail: "Email address",
    formEmailPh: "you@email.com",
    formPhone: "Phone",
    formPhonePh: "+34 600 000 000",
    formCar: "Car you're interested in",
    formCarNotSure: "Not sure yet",
    formMessage: "Message",
    formMessagePh: "Tell us what you're looking for...",
    formSubmit: "SEND MESSAGE",
    formSending: "SENDING...",
    thankYouTitle: "Message received",
    thankYouSub: "Thanks for reaching out. We'll get back to you as soon as possible.",
    formError: "The message couldn't be sent. Please try again or message us on WhatsApp.",
    footerRights: "All rights reserved.",
    footerTagline: "Used cars · Costa del Sol",
    whatsappFloat: "Message us on WhatsApp",
    whatsappDefaultMsg: "Hi, I'd like more information about your cars.",
    whatsappCarMsg: (title) => `Hi, I'm interested in the ${title}. Can you give me more information?`,
    backToCars: "← Back to all cars",
    year: "Year",
    km: "Mileage",
    transmission: "Transmission",
    fuel: "Fuel",
    power: "Power",
    color: "Colour",
    bodyType: "Type",
    contactAboutThisCar: "CONTACT ABOUT THIS CAR",
    whatsappAboutThisCar: "ASK ON WHATSAPP",
    notFoundTitle: "Car not found",
    notFoundSub: "This vehicle is no longer available or the link is incorrect.",
    pageNotFoundTitle: "Page not found",
    pageNotFoundSub: "The page you are looking for doesn't exist. Take a look at our available cars.",
    photoOf: (i, n) => `${i} / ${n}`,
    transmissionVals: { automatic: "Automatic", manual: "Manual" },
    fuelVals: {
      diesel: "Diesel",
      diesel_hybrid: "Diesel hybrid",
      gasoline: "Petrol",
      hybrid: "Hybrid",
      plugin_hybrid: "Plug-in hybrid",
    },
    colorVals: {
      blue: "Blue",
      dark_blue: "Dark blue",
      white: "White",
      silver: "Silver",
      black: "Black",
      red: "Red",
      grey: "Grey",
    },
    bodyTypeVals: {
      sedan: "Sedan",
      suv: "SUV",
      coupe: "Coupé",
      van: "Van",
      estate: "Estate",
      hatchback: "Hatchback",
      convertible: "Convertible",
      minivan: "Minivan",
    },
    descriptionTitle: "Description",
    highlightsTitle: "Highlights",
  },
};

const NUM_LOCALE = { es: "es-ES", en: "en-GB" };

export function formatNumber(n, lang) {
  return n.toLocaleString(NUM_LOCALE[lang] || "es-ES", { useGrouping: "always" });
}

export function formatPrice(price, lang) {
  return `${formatNumber(price, lang)} €`;
}

const LanguageContext = createContext(null);

// The language is derived from the URL (not from a stored preference), so
// each language has its own indexable, shareable URL:
//   /              -> Spanish (default)
//   /coche/:id/    -> Spanish car page
//   /en/           -> English
//   /en/coche/:id/ -> English car page
export function isEnglishPath(pathname) {
  return pathname === "/en" || pathname.startsWith("/en/");
}

export function stripLangPrefix(pathname) {
  if (!isEnglishPath(pathname)) return pathname;
  const rest = pathname.slice(3);
  return rest === "" ? "/" : rest;
}

export function withLang(pathname, lang) {
  const base = stripLangPrefix(pathname);
  const path = lang !== "en" ? base : base === "/" ? "/en/" : `/en${base}`;
  // Pages are served from folders (/coche/<id>/index.html), so the
  // trailing-slash form is the canonical URL — use it for every link.
  return path.endsWith("/") ? path : `${path}/`;
}

export function LanguageProvider({ children }) {
  const location = useLocation();
  const lang = isEnglishPath(location.pathname) ? "en" : "es";
  const t = DICTS[lang];

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return <LanguageContext.Provider value={{ lang, t }}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  return useContext(LanguageContext);
}
